import { Component } from '@angular/core';
import { ButtonComponent } from '@flowkit/button';
import { DialogRefService } from '@flowkit/dialog';

@Component({
  selector: `app-my-dialog`,
  imports: [ButtonComponent],
  template: `
    <div class="flex flex-col gap-10">
      <h1>{{ data.message }}</h1>
      <div class="flex justify-end">
        <button (click)="onClose()" flkButton>Close</button>
      </div>
    </div>
  `,
})
export class MyDialogComponent {
  data = this.dialogRef.data;
  constructor(private dialogRef: DialogRefService<MyDialogComponent>) {}

  onClose() {
    this.dialogRef.close({
      foo: 'bar',
    });
  }
}
